/*
 *  ~~~~~ Copyright by inndevs GmbH / DDC Engineering GmbH ~~~~~
 *
 *               Your favorite programmers ;-)
 *
 * E-Mail:   hannes@inndevs.com
 *           dominic@ddc-engineering.at
 * Web:      https://inndevs.com
 *           https://ddc-engineering.at
 * Date:     2021-05-16
 *
 *   ________________________________________
 * [[ MESS WITH THE BEST - DiE LIKE THE REST ]]
 *   ‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾
 */

import "./js/errorhandling"
import { createRoot } from 'react-dom/client';

import React from "react";
import App, {loadConfiguration} from "./App";
import { Amplify } from 'aws-amplify';

import {BrowserRouter} from "react-router-dom";
import {putGermanVocabulary} from "./js/translate";
import GlobalErrorBoundary from "./GlobalErrorBoundary";

( async () => {
    putGermanVocabulary();

    const config = await loadConfiguration()
        Amplify.configure({
            Auth:{
                Cognito: config.default['cognitoConfig']
            },
            API: {
                REST:
                    {
                        "key-direct-api":{
                            endpoint: config.default['endpoint'],
                            region: config.default['region'],
                        },
                        "local-test": {
                            endpoint: "http://localhost:3001"
                        }
                    }
            }
    });

    const container = document.getElementById('root');
    const root = createRoot(container);
    root.render(
        /*<React.StrictMode>*/
        <GlobalErrorBoundary>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </GlobalErrorBoundary>
        /*</React.StrictMode>*/
    );

})()



